import React from "react";
import "../styles/About.css";

const About = () => (
  <div className="about">
    <div className="about-me">
      <div className="photo">
        <img src={require("../img/mn.png")} alt="me" />
      </div>
      <div className="text">
        <p>
          Hi, my name is <strong>Mohit Negi</strong>. I'm currently working as a
          Software Developer @<strong> Humbleschool</strong>, an Ed-Tech startup
          creating software products to deliver high-quality content inculcating
          problem-solving ability in kids. I have done completed B.tech
          <strong> IIEST Shibpur</strong> (Depart. of Information Technology) in
          2019.
        </p>
        <p>
          It all started when I was in the 8th standard and I created a web page
          with basic HTML. Now I'm developing full-stack applications, mostly
          using React, Node and MongoDB (MERN stack). I tend to write clean and
          reusable, self-documented code that is easy to read and test. Always
          keep up with the latest technologies and best practices. Constantly
          learning new things, contributing to open source projects, and also
          love solving complex problems.
        </p>
      </div>
    </div>
    <div className="about-me">
      <div>
        <p>
          I believe if I am the smartest person in the room then probably I am
          in the wrong room. Other than staring at the screen confused I like to
          play and watch football, brainstorm for ideas for the next{" "}
          <strong>million</strong> download app, play computer games and watch
          TV series.
        </p>
        <p>
          <strong>"Stay hungry, stay foolish."</strong>
        </p>
      </div>
    </div>
    <div className="skills">
      <h3>SKILLS</h3>
      <img src={require("../img/html5.png")} alt="html5" />
      <img src={require("../img/css3.png")} alt="css3" />
      <img src={require("../img/javascript.png")} alt="javascript" />
      <img src={require("../img/node.png")} alt="node" />
      <img src={require("../img/express.png")} alt="express" />
      <img src={require("../img/mongodb.png")} alt="mongodb" />
      <img src={require("../img/react.png")} alt="react" />
      <img src={require("../img/redux.png")} alt="redux" />
      <img src={require("../img/material-ui.png")} alt="material-ui" />
      <img src={require("../img/webpack.png")} alt="webpack" />
      <img src={require("../img/jest.png")} alt="jest" />
      <img src={require("../img/git.png")} alt="git" />
      <img src={require("../img/linux.png")} alt="linux" />
    </div>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js